const getAttributeValue = (selector, attribute) => {
	const element = document?.querySelector(selector);
	const attributeValue = element?.getAttribute(attribute);

	return attributeValue;
};

export default getAttributeValue;
